import {
  NgModule
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';
import { PDFService } from "app/services/pdf/pdf.generation";
import { OWNERPDFService } from "app/services/pdf/ownerinfopdf.generation";
import { BUSINESSGROUPRPDFService } from "app/services/pdf/businessgrouppdf.generation";
import { BUSINESSREFService } from "app/services/pdf/businessref.generation";
import { FINANCIALService } from "app/services/pdf/financialpdf.generation";
import { PRIVACYService } from "app/services/pdf/privacypdf.generation";
import { DECLARATIONService } from "app/services/pdf/declarationpdf.generation";
import { GUARANTEEService } from "app/services/pdf/guaranteepdf.generation";
import { MarketPDFService } from "app/services/pdf/marketpdf.generation";
import { SharedPdfService } from 'app/services/shared/shared-pdf.service';
import { SharedModule } from 'app/services/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [PDFService, OWNERPDFService, BUSINESSGROUPRPDFService, BUSINESSREFService, FINANCIALService,
                PRIVACYService, DECLARATIONService, GUARANTEEService,MarketPDFService],
  declarations: []
})
export class PDFModule { }



// WEBPACK FOOTER //
// ./src/app/services/pdf/pdf.module.ts